import { Link } from "react-router-dom";
import { Globe, Mail } from "lucide-react";
import { EMAIL } from "../data/content";
import BrandMark from "./BrandMark";

const columns = [
  {
    title: "Navigate",
    links: [
      { to: "/", label: "Home" },
      { to: "/services", label: "Services" },
      { to: "/solutions", label: "Solutions" },
      { to: "/outsourcing", label: "Outsourcing" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about", label: "About" },
      { to: "/careers", label: "Careers" },
      { to: "/contact", label: "Contact" },
    ],
  },
];

export const Footer = () => (
  <footer className="site-footer relative" data-testid="main-footer">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <Link to="/" className="brand-link flex items-center gap-3" data-testid="footer-logo">
            <span className="brand-mark relative grid h-10 w-10 place-items-center rounded-xl">
              <BrandMark className="h-full w-full" />
            </span>
            <span className="leading-none">
              <span className="brand-name block font-display text-base font-bold tracking-tight">
                Spark Link
              </span>
              <span className="brand-subtitle mt-1 block font-mono text-[9px] uppercase tracking-[0.32em]">
                IT Solutions
              </span>
            </span>
          </Link>
          <p className="footer-lead mt-6 max-w-sm font-display text-lg font-medium">
            Technology That Moves Your Business Forward.
          </p>
          <p className="footer-note mt-3 font-mono text-xs tracking-wide">
            Custom Software · Automation · AI · Cloud · IT Solutions
          </p>
          <div className="mt-8 space-y-3">
            <a
              href={`mailto:${EMAIL}`}
              data-testid="footer-email-link"
              className="footer-link flex items-center gap-3 text-sm transition-colors duration-300"
            >
              <Mail className="footer-icon h-4 w-4" />
              {EMAIL}
            </a>
            <p className="footer-copy flex items-center gap-3 text-sm">
              <Globe className="footer-icon h-4 w-4" />
              Based in India. Working with clients globally.
            </p>
          </div>
        </div>

        {columns.map((col) => (
          <div key={col.title} className="lg:col-span-3">
            <p className="footer-heading font-mono text-xs uppercase tracking-[0.25em]">
              {col.title}
            </p>
            <ul className="mt-5 space-y-3">
              {col.links.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                    className="footer-link text-sm transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="footer-bottom mt-16 flex flex-col items-start justify-between gap-4 pt-8 sm:flex-row sm:items-center">
        <p className="footer-note text-xs">
          © Spark Link IT Solutions. All rights reserved.
        </p>
        <p className="footer-motto font-mono text-xs tracking-[0.25em] uppercase">
          Think. Build. Evolve.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
